/**
 * Ngày giờ cho giao diện quầy — mọi phép tính đi qua `@sapa/shared/time` (CLAUDE.md §3).
 * Không `getHours()`: máy quầy có thể đặt sai múi giờ, còn nghiệp vụ luôn ở giờ Việt Nam.
 */
import { formatVnDateFull, formatVnDateShort, nowVn, toMinuteOfDay } from '@sapa/shared'

/** `"2026-09-21"` → `"Thứ Hai, 21/09/2026"`. */
export const nhanNgayDayDu = formatVnDateFull
/** `"2026-09-21"` → `"Thứ Hai, 21/09"`. */
export const nhanNgayNgan = formatVnDateShort

/** Phút-từ-nửa-đêm của lúc này, theo giờ Việt Nam (cho vạch "bây giờ" trên lịch). */
export function phutBayGio(): number {
  return toMinuteOfDay(nowVn())
}
